import { render } from "./popDialogDrag.vue?vue&type=template&id=73701368&scoped=true"
import script from "./popDialogDrag.vue?vue&type=script&lang=js"
export * from "./popDialogDrag.vue?vue&type=script&lang=js"

import "./popDialogDrag.vue?vue&type=style&index=0&id=73701368&scoped=true&lang=css"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73701368"]])

export default __exports__